import { z } from "zod";
import { conversionGetBaseSchema } from "./conversionGetBaseSchema";
import { ecommerceConversionFiltersGetSchema } from "./conversionFiltersGetSchema";

export const placedOrderConversionGetSchema = z.object({
  ...conversionGetBaseSchema.shape,
  event_type: z.literal("TrackedUserBehavior::PerformedOrderPlaced"),
  is_any_order: z.boolean(),
  product_key: z.string().nullable().optional(),
  product_value: z.string().nullable().optional(),
  filter_description: z.string().optional(),
  filters: ecommerceConversionFiltersGetSchema.optional(),
});
